import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
} from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import { MatDatepicker } from "@angular/material/datepicker";
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexLegend,
  ApexDataLabels,
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions; // 👈 thêm dòng này
};

@Component({
  selector: "app-zns-extend-manager",
  templateUrl: "./zns-extend-manager.component.html",
  styleUrls: ["./zns-extend-manager.component.scss"],
})
export class ZnsExtendManagerComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  tableName = "zns-expired-autodebit-targets";

  listData = [];
  pageSize = 10;
  pageIndex = 1;
  params = "";
  searching = false;
  totalCount = 0;

  filter = {
    send_status: "ALL",
    status: "ALL",
    cif: "",
    phone: "",
    terminal_bank_acc: "",
    serial_number: "",
  };

  listStatusSend = [
    { value: "ALL", label: "Tất cả" },
    { value: "PENDING", label: "Chờ gửi" },
    { value: "SENDING", label: "Đang gửi" },
    { value: "SENT", label: "Đã gửi" },
    { value: "FAILED", label: "Gửi lỗi" },
  ];
  listStatus = [
    { value: "ALL", label: "Tất cả" },
    { value: "AGREED", label: "Đồng ý" },
    { value: "CANCELED", label: "Huỷ dịch vụ" },
  ];
  role = JSON.parse(localStorage.getItem("currentUser"))?.role;
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<ChartOptions>;

  ngOnInit() {
    if (this.role === "admin") {
      this.reloadPage();
    }
  }
  summary;
  fetchData() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName +
          `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res.metadata?.results || [];
          this.totalCount = res.metadata?.pagination?.totalCount || 0;
          this.eventService.setLoading(false);
        },
        error: () => {
          this.eventService.setLoading(false);
        },
      });
  }
  fetchDataChart() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        "zns-expired-autodebit-targets/summary" +
          `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.summary = res?.metadata;
          if (this.summary) {
            this.chartOptions = {
              series: [
                this.summary.pendingCount || 0,
                this.summary.sentCount || 0,
                this.summary.failedCount || 0,
              ],
              chart: {
                type: "donut",
                height: 320,
              },
              labels: ["Chờ gửi", "Đã gửi", "Gửi lỗi"],
              colors: ["#74788d", "#1cbb8c", "#ff3d60"],
              legend: {
                position: "bottom",
              },
              dataLabels: {
                enabled: true,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        show: true,
                        label: "Tổng",
                        formatter: () => {
                          return this.summary?.totalCount || 0;
                        },
                      },
                    },
                  },
                },
              },
            };
            this.chartOptions2 = {
              series: [
                this.summary.agreedCount || 0,
                this.summary.canceledCount || 0,
              ],
              chart: {
                type: "donut",
                height: 320,
              },
              labels: ["Đồng ý", "Huỷ dịch vụ"],
              colors: ["#1cbb8c", "#ff3d60"],
              legend: {
                position: "bottom",
              },
              dataLabels: {
                enabled: true,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        show: true,
                        label: "Tổng",
                        formatter: () => {
                          return (
                            this.summary?.canceledCount +
                              this.summary?.agreedCount || 0
                          );
                        },
                      },
                    },
                  },
                },
              },
            };
          }

          this.eventService.setLoading(false);
        },
        error: () => {
          this.eventService.setLoading(false);
        },
      });
  }
  submitFilter() {
    this.params = "";
    let hasFilter = false;

    Object.keys(this.filter).forEach((key) => {
      const value = this.filter[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== "ALL"
      ) {
        hasFilter = true;
        this.params += `&${key}=${value}`;
      }
    });

    // 🚨 Nếu không có filter nào → return luôn
    if (!hasFilter) {
      return;
    }

    this.pageIndex = 1;
    this.searching = true;
    this.reloadPage();
  }

  clearFilter() {
    this.params = "";
    this.filter = {
      send_status: "ALL",
      cif: "",
      status: "ALL",
      phone: "",
      terminal_bank_acc: "",
      serial_number: "",
    };
    this.searching = false;
    this.pageIndex = 1;
    this.listData = [];
    this.totalCount = 0;
    this.reloadPage();
  }

  sendStatusInfo: {
    [key: string]: { label: string; color: string };
  } = {
    PENDING: { label: "Chờ gửi", color: "#74788d" },
    SENDING: { label: "Đang gửi", color: "#3b82f6" },
    SENT: { label: "Đã gửi", color: "#1cbb8c" },
    FAILED: { label: "Gửi lỗi", color: "#ff3d60" },
  };

  getSendStatusInfo(status: string) {
    return this.sendStatusInfo[status] || { label: status, color: "#74788d" };
  }

  responseInfo: {
    [key: string]: { label: string; color: string };
  } = {
    AGREED: { label: "Đồng ý", color: "#1cbb8c" },
    CANCELED: { label: "Huỷ dịch vụ", color: "#ff3d60" },
  };

  getResponseInfo(status: string) {
    return this.responseInfo[status] || null;
  }
  reloadPage() {
    this.fetchData();
    this.fetchDataChart();
  }
  showUpdateNoteModal(data: any) {
    Swal.fire({
      title: "Cập nhật thông tin",
      html: `
        <div style="text-align:left">
  
          <label style="margin-bottom:6px; display:block;">Ghi chú</label>
          <textarea id="swal-note" class="swal2-textarea"
            placeholder="Nhập nội dung ghi chú...">${data.note || ""}</textarea>
  
          <label style="margin:12px 0 6px; display:block;">Trạng thái tin nhắn</label>
          <select id="swal-status" class="swal2-input">
            <option value="">-- Chọn trạng thái --</option>
            <option value="AGREED" ${
              data.status === "AGREED" ? "selected" : ""
            }>Đồng ý</option>
            <option value="CANCELED" ${
              data.status === "CANCELED" ? "selected" : ""
            }>Huỷ dịch vụ</option>
          </select>
  
          <label style="margin:12px 0 6px; display:block;">Thời gian</label>
          <input id="swal-contact_time" type="date" class="swal2-input"
            value="${data.contact_time || ""}" />
  
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Cập nhật",
      cancelButtonText: "Hủy",
      reverseButtons: true,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const note = (
          document.getElementById("swal-note") as HTMLTextAreaElement
        )?.value;
        const status = (
          document.getElementById("swal-status") as HTMLSelectElement
        )?.value;
        const contact_time = (
          document.getElementById("swal-contact_time") as HTMLInputElement
        )?.value;

        // ✅ Validate bắt buộc đủ thông tin
        if (!note || note.trim() === "") {
          Swal.showValidationMessage("Vui lòng nhập ghi chú!");
          return false;
        }

        if (!status) {
          Swal.showValidationMessage("Vui lòng chọn trạng thái!");
          return false;
        }

        if (!contact_time) {
          Swal.showValidationMessage("Vui lòng chọn ngày!");
          return false;
        }

        // ✅ Trả về Promise để Swal chờ API
        return new Promise((resolve, reject) => {
          this.apiService
            .pacth(`${this.tableName}`, `${data.id}`, {
              note: note.trim(),
              status: status,
              contact_time: contact_time,
            })
            .subscribe({
              next: () => {
                // cập nhật lại table local
                data.note = note.trim();
                data.status = status;
                data.contact_time = contact_time;

                resolve(true);
              },
              error: (e) => {
                Swal.showValidationMessage(
                  e?.error?.message || "Có lỗi xảy ra khi cập nhật"
                );
                reject(false);
              },
            });
        });
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Thành công",
          text: "Cập nhật thông tin thành công!",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  }

  updateNote(rowData: any, dataPost: any) {
    this.eventService.setLoading(true);

    this.apiService
      .pacth(`${this.tableName}/${rowData.id}`, "", dataPost)
      .subscribe({
        next: () => {
          Swal.fire({
            icon: "success",
            title: "Thành công",
            text: "Cập nhật thông tin thành công!",
            timer: 2000,
            showConfirmButton: false,
          });

          // Update UI ngay không cần reload
          rowData.note = dataPost.note;
          rowData.status = dataPost.status;
          rowData.contact_time = dataPost.contact_time;

          this.eventService.setLoading(false);
        },
        error: (e) => {
          Swal.fire({
            icon: "error",
            title: "Lỗi",
            text: e?.error?.message || "Có lỗi xảy ra khi cập nhật",
          });
          this.eventService.setLoading(false);
        },
      });
  }
}
